import { render, staticRenderFns } from "./RecentlyAddedJobsList.vue?vue&type=template&id=ade18418&"
import script from "./RecentlyAddedJobsList.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedJobsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports